import { ClassNameProps, englishCommaJoinStrings, Row, StyleProps, trimPrefix } from "@hex-insights/core";
import { Badge } from "../../../../Components/Badge";
import { Icon } from "../../../../Components/Icon";
import { ClassYear } from "../../../../Utilities";
import { ClassYearFormat } from "../../../Format";

export type ClassYearsBadgeProps = {
	classYears: Pick<ClassYear, "name">[];
	slim?: boolean;
} & Partial<ClassNameProps & StyleProps>;

export function ClassYearsBadge({ classYears, slim = false, className, style }: ClassYearsBadgeProps) {
	if (classYears.length === 0) {
		return null;
	}

	let text = "";
	if (classYears.length === 1) {
		text = slim ? ClassYearFormat.abbreviatedName(classYears[0]) : ClassYearFormat.name(classYears[0]);
	} else {
		const yearNumbers = classYears.map((e) => trimPrefix(e.name, "Year").trim());
		const yearNumbersText = englishCommaJoinStrings(yearNumbers, "&");
		text = slim ? yearNumbersText : `Years ${yearNumbersText}`;
	}

	return (
		<Badge className={className} style={style}>
			<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
				<Icon.GraduationCap size={16} /> {text}
			</Row>
		</Badge>
	);
}
